import { applyWorkFlowKeyMap } from '@/components/WorkFlow/constants';
import { reqGetFormListByOrg } from '@/routes/ExecutionUnit/services';
import { commonPlace } from '@/services/user';
import { queryWorkFlowInfo } from '@/services/workflow';
import { sortBy } from 'lodash';
import { zlbApiExpenseCommonDicGetPost } from 'src/api/zlbExpense';
import { getOperatorInfo } from 'src/common/services/app';
import { fetchBusinessConfig } from 'src/routes/Claim/services';
import {
  auditWorkFlow,
  calculateFurnitureEequipment,
  calLeaveDuration,
  compareTime,
  getDataSourceOptions,
  getLastCommonInfo,
  getLeaveDetail,
  getLeaveType,
  getPurchaseDirectory,
  getPurchaseItem,
  getRentalDetail,
  initRentalInfo,
  queryFormDefineByCode,
  reqAllCompanyInfo,
  reqApplyCreateOrSave,
  reqApplyDelete,
  reqApplyDetail,
  reqApplySubmit,
  reqCompanyInfo,
  stopWorkFlow,
  submitLeave,
  submitWorkFlow,
} from '../services/index';

const formatData = (data = []) => {
  return data?.map(i => ({
    label: i.name,
    value: i.code || i.key,
    ...i,
    children: i.children && i.children.length > 0 ? formatData(i.children) : null,
  }));
};

// 递归遍历数据
const formatMenusTree = (data = []) => {
  return (data || [])?.map(i => ({
    ...i,
    label: i.directoryName,
    value: i.directoryEncoding,
    children: i.child && i.child.length > 0 ? formatMenusTree(i.child) : null,
  }));
};

export default {
  namespace: 'applyManage',
  state: {
    detail: {},
    purchaseDetail: {},
    reRequest: false,
    expenseType: [],
    companyInfo: {},
    applyUserName: '', // 当前登陆人
    currentOperator: {}, // 当前登录人信息
    updateWorkFlowDataFunc: () => {},
    purchaseData: [], // 采购目录
    purchaseServicesData: [], // 采购服务
    purchaseItems: [], // 资产类目
    workFlowData: {}, // 工作流数据
    cacheWorkFlowInfo: {},
    startCityList: [], // 常用出发地
    endCityList: [], // 常用目的地
    periodType: undefined,
    isPdfFormat: false,
    dataSourceOptions: [], // 申请单来源列表
    treeFlag: false,
    departmentTree: {},
    departmentList: [],
    defaultCity: {},
    companyDepartmentInfo: {},
    lastFormInfo: {}, // 上次单据的信息，用于用户在报销单填写时使用
  },
  effects: {
    *changeDetail({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          detail: payload || {},
        },
      });
    },
    *changeReRequest(_, { put, select }) {
      const reRequest = yield select(state => state.reRequest);
      yield put({
        type: 'update',
        payload: {
          reRequest: !reRequest,
        },
      });
    },
    *fetchDetail({ payload }, { call, put, select }) {
      const result = yield call(reqApplyDetail, payload);
      let temp = {
        detail: result,
      };

      if (result?.applyFormType === 19) {
        const purchaseDetails = yield select(state => state.applyManage?.purchaseDetail);
        purchaseDetails[result?.applyFormCode] = result;
        temp = purchaseDetails;
      }
      // applyFormType==19 采购单单据类型，防止打开其他采购类型单据数据detail数据被刷新重新定义purchaseDetail字段
      yield put({
        type: 'update',
        payload: temp,
      });
      return result;
    },
    *fetchExpenseType({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseCommonDicGetPost, payload);
      const { values } = result?.length && result[0];
      const travelTypes = (values || [])?.map(item => ({
        businessType: item.key,
        businessTypeName: item.desc,
      }));
      yield put({
        type: 'update',
        payload: {
          expenseType: travelTypes,
        },
      });
      return travelTypes;
    },
    *fetchCompanyInfo({ payload }, { call, put }) {
      const result = yield call(reqCompanyInfo, payload);
      const departmentList =
        result?.departmentList?.map(i => ({
          ...i,
          fullName: `${i.parentDeptName || result.orgName}${
            i.deptId === -1 ? '' : '-' + i.deptName
          }`,
        })) || [];
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          companyDepartmentInfo: result || {},
          departmentList,
          treeFlag: result?.treeFlag,
          departmentTree: result?.departmentTree || {},
          defaultCity: {
            cityCode: result?.cityCode
              ? result?.cityCode.split(',').map(item => item.toString())
              : null,
            cityName: result?.cityName ? result?.cityName.split(',') : null,
          },
        },
      });
      return result;
    },
    *fetchAllDepartmentList({ payload }, { call, put }) {
      const result = yield call(reqAllCompanyInfo, payload);
      const departmentList =
        result.departmentInfoDtoList?.map(i => ({
          ...i,
          fullName: `${result.institutionName} ${
            i.departmentId === -1 ? '' : '- ' + i.departmentName
          }`,
        })) || [];
      result.allDepartmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          companyInfo: result || {},
        },
      });
      return result;
    },

    *fetchCommonDic({ payload }, { call }) {
      return yield call(zlbApiExpenseCommonDicGetPost, payload);
    },
    // 获取工作流详情
    *getWorkFlowInfo({ payload }, { call, put, select }) {
      const result = yield call(queryWorkFlowInfo, payload);
      const cacheWorkFlowInfo = yield select(state => state.claim.cacheWorkFlowInfo);
      // 根据工作流的key建立独立的队列 队列长度5
      cacheWorkFlowInfo[payload.workflowProcessKey] =
        cacheWorkFlowInfo[payload.workflowProcessKey] || {};
      const keyMap = cacheWorkFlowInfo[payload.workflowProcessKey];
      keyMap[new Date().getTime()] = result;
      const keysArr = sortBy(Object.keys(keyMap));
      if (keysArr.length > 5) {
        Reflect.deleteProperty(keyMap, keysArr[0]);
      }
      const valueArr = keysArr?.map(i => keyMap[i]);
      // 之前没回来的请求，以最新数据返回
      const lastestResult = valueArr[valueArr.length - 1];
      yield put({
        type: 'update',
        payload: {
          workFlowData: lastestResult || {},
          cacheWorkFlowInfo,
        },
      });
      return lastestResult;
    },
    // 提交工作流
    *submitWorkFlow({ payload }, { call }) {
      return yield call(submitWorkFlow, payload);
    },
    // 审批工作流
    *auditWorkFlow({ payload }, { call }) {
      return yield call(auditWorkFlow, payload);
    },
    // 停止工作流
    *stopWorkFlow({ payload }, { call }) {
      return yield call(stopWorkFlow, payload);
    },
    // 获取当前登陆人信息
    *fetchApplyUserName({ payload }, { call, put }) {
      const res = yield call(getOperatorInfo, payload);
      yield put({
        type: 'update',
        payload: {
          applyUserName: res.result.displayName,
          currentOperator: res.result,
        },
      });
    },
    *setUpdateWorkFlowDataFunc({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          updateWorkFlowDataFunc: payload,
        },
      });
    },
    // 获取采购目录
    *getPurchaseDirectory({ payload }, { call, put }) {
      const res = yield call(getPurchaseDirectory, payload);
      yield put({
        type: 'update',
        payload:
          payload?.purchaseType === 2
            ? {
                purchaseServicesData: formatMenusTree(res),
              }
            : {
                purchaseData: formatMenusTree(res),
              },
      });
    },
    // 资产类目
    *getPurchaseItem({ payload }, { call, put }) {
      const res = yield call(getPurchaseItem, payload);
      yield put({
        type: 'update',
        payload: {
          purchaseItems: formatData(res),
        },
      });
    },
    // 计算办公设备家具采购申请单限额
    *calculateFurnitureEequipment({ payload }, { call }) {
      return yield call(calculateFurnitureEequipment, payload);
    },
    // 保存申请单
    *applyCreateOrSave({ payload }, { call }) {
      return yield call(reqApplyCreateOrSave, payload);
    },
    // 提交申请单
    *applySubmit({ payload }, { call }) {
      return yield call(reqApplySubmit, payload);
    },
    *applyDelete({ payload }, { call }) {
      return yield call(reqApplyDelete, payload);
    },

    // 比较时间
    *compareTime({ payload }, { call }) {
      const res = yield call(compareTime, payload);
      return res;
    },

    *getCommonPlace({ payload }, { call, put }) {
      const { cityType } = payload;
      const result = yield call(commonPlace, payload);
      yield put({
        type: 'update',
        payload:
          cityType === 1
            ? {
                startCityList: result || [],
              }
            : {
                endCityList: result || [],
              },
      });
      return result;
    },

    *getDataSourceOptions({ payload }, { call, put }) {
      const result = yield call(getDataSourceOptions, payload);
      yield put({
        type: 'update',
        payload: {
          dataSourceOptions: result || [],
        },
      });
      return result;
    },
    // 获取百搭列表
    *getBaidaFormList({ payload }, { call }) {
      const res = yield call(reqGetFormListByOrg, {
        enable: true,
        formDefineType: 1, // 申请单
        pageSize: 999,
        pageNo: 1,
        orgId: window?.currentUserIdentity?.institutionId,
        ...payload,
      });
      return res?.result || [];
    },
    // 根据业务code获取单据详情
    *queryFormDefineByCode({ payload }, { call, put }) {
      const { applyFormInfo, applyFormType } = payload;
      const params = {};
      params[7] = {
        code: 'zcy.baida.queryFormDefine',
        param: {
          getWorkflowInfo: {
            workflowProcessKey: applyWorkFlowKeyMap[7],
            formType: 1,
          },
          getApplyFormInfo: {
            ...applyFormInfo,
          },
          getFormInfo: {
            bizCode: payload.applyFormInfo.formCode,
          },
        },
      };
      const res = yield call(queryFormDefineByCode, {
        ...params[applyFormType],
      });
      const { result } = res.result;
      yield put({
        type: 'update',
        payload: {
          detail: result?.applyFormInfo || {},
        },
      });
      if (!result?.formInfo?.formSnapshotCode) return false;
      return result;
    },
    // 假期类型查询
    *getLeaveType({ payload }, { call }) {
      const res = yield call(getLeaveType, payload);
      return res;
    },
    // 计算请假时长
    *calLeaveDuration({ payload }, { call }) {
      const res = yield call(calLeaveDuration, payload);
      return res;
    },
    // 请假单提交
    *submitLeave({ payload }, { call }) {
      const res = yield call(submitLeave, payload);
      return res;
    },
    // 请假单查看详情
    *getLeaveDetail({ payload }, { call }) {
      const res = yield call(getLeaveDetail, payload);
      return res;
    },

    // 租车单详情
    *getRentalDetail({ payload }, { call }) {
      const res = yield call(getRentalDetail, payload);
      return res;
    },
    *initRentalInfo({ payload }, { call }) {
      const res = yield call(initRentalInfo, payload);
      return res;
    },
    *fetchBusinessConfig({ payload }, { call, put }) {
      const result = yield call(fetchBusinessConfig, [
        {
          key: 'zlb_expense_travel_itinerary_period_model',
        },
        {
          key: 'isPdfFormat_travelMeetingFile',
        },
      ]);
      yield put({
        type: 'update',
        payload: {
          periodType: result?.['zlb_expense_travel_itinerary_period_model'],
          isPdfFormat: result?.['isPdfFormat_travelMeetingFile'] === 'true',
        },
      });
      return result;
    },
    *getLastCommonInfo({ payload }, { call, put }) {
      const res = yield call(getLastCommonInfo, payload);

      yield put({
        type: 'update',
        payload: {
          lastFormInfo: res,
        },
      });
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
